import type { FC } from "react";

export const CloseMenuIcon: FC = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.4502 7.55022C16.8407 7.94074 16.8407 8.57391 16.4502 8.96443L13.4147 12L16.4502 15.0355C16.8407 15.426 16.8407 16.0592 16.4502 16.4497C16.0597 16.8402 15.4265 16.8402 15.036 16.4497L12.0005 13.4142L8.96492 16.4497C8.5744 16.8402 7.94123 16.8402 7.55071 16.4497C7.16018 16.0592 7.16018 15.426 7.55071 15.0355L10.5862 12L7.55071 8.96443C7.16018 8.57391 7.16018 7.94074 7.55071 7.55022C7.94123 7.15969 8.57439 7.15969 8.96492 7.55022L12.0005 10.5858L15.036 7.55022C15.4265 7.15969 16.0597 7.15969 16.4502 7.55022Z"
        fill="#A10F04"
      />
    </svg>
  );
};
